import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconAviSizeM from './FileIconAvi_size_m';
import FileIconAviSizeS from './FileIconAvi_size_s';

export const FileIconAvi = createFileIcon({
  m: FileIconAviSizeM,
  s: FileIconAviSizeS,
  name: 'FileIconAvi',
});
